import { RightioWBSAPIModelsUdtUdtServiceAgreementCustomer } from "@src/utilities/apis/wbs/model";
import { ui, state } from "../../../../interfaces/interfaces";
import { apiCCM } from "@services/CCMAccess/apiAccess";

export class ServiceAgreementCustomer implements RightioWBSAPIModelsUdtUdtServiceAgreementCustomer {
  constructor() {
    this.#serviceAgreementCustomerId = -1;
    this.#title = "";
    this.#forename = "";
    this.#surname = "";
    this.#telephoneLandline = "";
    this.#telephoneMobile = "";
    this.#emailAddress = "";
  }

  #serviceAgreementCustomerId: number;
  #title: string;
  #forename: string;
  #surname: string;
  #telephoneLandline: string;
  #telephoneMobile: string;
  #emailAddress: string;

  toObject(): any {
    return {
      _serviceAgreementCustomerId: this.#serviceAgreementCustomerId,
      _title: this.#title,
      _forename: this.#forename,
      _surname: this.#surname,
      _telephoneLandline: this.#telephoneLandline,
      _telephoneMobile: this.#telephoneMobile,
      _emailAddress: this.#emailAddress,
    };
  }

  // toRequest(): CareClubAPIModelsUdtUdtServiceAgreementCustomer {
  //   return {
  //     serviceAgreementCustomerId: this.#serviceAgreementCustomerId,
  //     title: this.#title,
  //     forename: this.#forename,
  //     surname: this.#surname,
  //     telephoneLandline: this.#telephoneLandline,
  //     telephoneMobile: this.#telephoneMobile,
  //     emailAddress: this.#emailAddress,
  //   };
  // }

  createCustomerInDatabase = async () => {
    const customer = await apiCCM.postApiCCMCustomerCreate({
      forename: ui.CarePlanBillingContactFirstName,
      surname: ui.CarePlanBillingContactLastName,
      emailAddress: ui.CarePlanBillingContactEmail,
      telephoneMobile: ui.CarePlanBillingContactMobile || undefined,
      telephoneLandline: ui.CarePlanBillingContactLandline || undefined,
      id: 0,
      title: ui.CarePlanBillingContactTitle || "",
      serviceAgreementIds: [],
    }, { userId: state.UserId });

    if (!customer || !customer.customerId) return;
    this.#serviceAgreementCustomerId = customer.customerId;
    return customer.customerId;
  }

  public get serviceAgreementCustomerId(): number {
    return this.#serviceAgreementCustomerId;
  }

  public set serviceAgreementCustomerId(serviceAgreementCustomerId: number) {
    this.#serviceAgreementCustomerId = serviceAgreementCustomerId;
  }

  public get title(): string {
    return this.#title;
  }

  public set title(title: string) {
    this.#title = title;
  }

  public get forename(): string {
    return this.#forename;
  }

  public set forename(forename: string) {
    this.#forename = forename;
  }

  public get surname(): string {
    return this.#surname;
  }

  public set surname(surname: string) {
    this.#surname = surname;
  }

  public get telephoneLandline(): string {
    return this.#telephoneLandline;
  }

  public set telephoneLandline(telephoneLandline: string) {
    this.#telephoneLandline = telephoneLandline;
  }

  public get telephoneMobile(): string {
    return this.#telephoneMobile;
  }

  public set telephoneMobile(telephoneMobile: string) {
    this.#telephoneMobile = telephoneMobile;
  }

  public get emailAddress(): string {
    return this.#emailAddress;
  }

  public set emailAddress(emailAddress: string) {
    this.#emailAddress = emailAddress;
  }
}
